import React, {Component} from 'react'
//import TweenLite from "gsap/TweenLite";
//import {Expo} from "gsap/EasePack";
import {
  withRouter
} from 'react-router-dom';

/*

Add this to index.html
<script src="//cdnjs.cloudflare.com/ajax/libs/gsap/2.0.2/TweenMax.min.js"></script>
<script src="//cdnjs.cloudflare.com/ajax/libs/gsap/2.0.2/easing/EasePack.min.js"></script>
<script src="//cdnjs.cloudflare.com/ajax/libs/gsap/2.0.2/plugins/ScrollToPlugin.min.js"></script>    

*/

const TweenLite = window.TweenLite;
const Expo = window.Expo;

/*

ScrollTo - scroll the .Site pos when the page changes

*/

class ScrollTo extends Component {

  animating=0;
  stopListening;

  constructor(props) {

      super(props);
      

  }
	
  componentDidMount() {

       
        this.animate(this.props);
        
        window.TweenLite = TweenLite;

  }



 componentWillReceiveProps(nextProps) {
   
      const currentPage = this.props.location.pathname;
      const nextPage = nextProps.location.pathname;
      //alert(this.props.update+' '+nextProps.update);
      if (this.props.key != nextProps.key || this.props.to != nextProps.to || this.props.update != nextProps.update) {
        this.animate(nextProps);
      }
    }

  animate = (props) => {
      const _this = this;

      if(props.to == '#') return;
     
      //if(_this.animating) return;

      let scroller = (props.scroller) ? document.querySelector(props.scroller) : window;
      let duration = (props.hasOwnProperty('duration')) ? props.duration : 1.5;
      
      let offset = props.offset || 0;
      let to = props.to || props.pos;

      if(offset && to.match('#')){

          let el = document.querySelector(props.to);
          let pos = el.offsetTop + window.innerHeight;
          let offsetAmt = (typeof offset == 'function') ? offset(el) : offset;
          to = pos - offsetAmt;

      }

       _this.animating = 1;

       setTimeout(function(){
          
          TweenLite.to(scroller,duration,{scrollTo:{y:to,autoKill:false},ease:Expo.easeInOut,onComplete:function(){
       
            _this.animating = 0;
        

          }});

       },100);
      

  }

  render () {

    return (

      <div ref="el">

        { this.props.children }

      </div>
    )
  }
}

export default withRouter(ScrollTo);



// WEBPACK FOOTER //
// ./src/js/_core/components/ScrollTo/ScrollTo.jsx